var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89.641mm",
    height: "93.592mm",
    viewBox: "0 0 89.641 93.592",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-115.31 -96.087)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#a9bacd",
    strokeWidth: 0.26458,
    "aria-label": "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m204.33 132.39c-2.346-22.842-17.533-36.301-44.697-36.301-24.818 0-44.326 17.903-44.326 46.672 0 28.892 17.78 46.919 47.166 46.919 23.46 0 39.881-13.829 42.474-36.795h-28.028c-1.1112 8.5196-5.5562 15.064-14.94 15.064-14.817 0-17.533-11.73-17.533-24.201 0-17.163 6.1736-25.929 16.422-25.929 9.1369 0 14.94 5.3093 15.804 14.57z",
    fill: "#a9bacd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCLogo);
export default __webpack_public_path__ + "static/media/cLogo.a3889c7b0da2454f151eeb07163da1bc.svg";
export { ForwardRef as ReactComponent };